module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_8_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_8_before.jpg
// module id = 1172
// module chunks = 0